export default "__VITE_ASSET__D_sgc76z__"